import React from 'react';
import styles from './Button4.module.css';

const Button4 = ({ text, color, bgColor }) => {
  return (
    <button
        className={styles.btn}
      style={{
        color: color,
        backgroundColor: bgColor,
        
      }}
    >
      {text}
    </button>
  );
};

export default Button4;